import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=97beef78&scoped=true&"
import script from "./ErrorNotification.vue?vue&type=script&lang=ts&"
export * from "./ErrorNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&id=97beef78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97beef78",
  null
  
)

export default component.exports